// hooks/useClients.ts
import { useEffect } from 'react';
import { message } from 'antd';
import { useProposalStore } from '../store/proposalStore';
import api from '../services/api';
export default function useClients() {
  const { addClient, clearClient } = useProposalStore();

  const fetchClients = async () => {
    clearClient();
    try {
      const res = await api.get('/clients');
      res.data.forEach(client => addClient(client));
    } catch {
      message.error('Erro ao buscar clientes');
    }
  };

  const addNewClient = async (values) => {
    try {
      await api.post('/clients', values);
      await fetchClients();
      message.success('Cliente adicionado com sucesso!');
    } catch {
      message.error('Erro ao adicionar cliente');
    }
  };

  return { fetchClients, addNewClient };
}
